'use strict';

module.exports = function () {
  return global.location.protocol === 'http:';
};



//////////////////
// WEBPACK FOOTER
// ./~/braintree-web/client/request/is-http.js
// module id = 515
// module chunks = 1